import {SecureService} from "@/services/superclasses/secure-service";
import {Hire} from "@/interfaces/hire";

const api = window.contextPath + '/rest/hires';

export class HireSecureService extends SecureService {

    public loadAll = async (): Promise<Hire[]> => {
        return this.data(await this.get<Hire[]>(api))
    }
}

export const hireSecureService = new HireSecureService()